import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import './NewsInsights.css';

// Import the icon we'll need for the scroll arrow
import { FiArrowRight } from 'react-icons/fi';

// Import all the new images you just saved
import wheatIndexImg from '../../assets/images/news-wheat-index.png';
import reservoirLevelsImg from '../../assets/images/news-reservoir-levels.png';
import regionStorageImg from '../../assets/images/news-region-storage.png';
import rainfallImg from '../../assets/images/news-rainfall.png';
import maizeSeasonalityImg from '../../assets/images/news-maize-seasonality.png';
import maizeProductionImg from '../../assets/images/news-maize-production.png';
// Array of our news data
const newsData = [
  {
    image: wheatIndexImg,
    title: 'India\'s Wheat Price Index shows volatility ahead of harvest season.',
    tags: ['Wheat', 'INSIGHT'],
    date: 'November 2, 2025'
  },
  {
    image: reservoirLevelsImg,
    title: 'Reservoir storage levels critical for upcoming Rabi crop season.',
    tags: ['Water', 'INSIGHT'],
    date: 'November 1, 2025'
  },
  {
    image: regionStorageImg,
    title: 'Region-wise analysis of water storage positions across India.',
    tags: ['Data', 'INSIGHT'],
    date: 'October 31, 2025'
  },
  {
    image: rainfallImg,
    title: 'Post-monsoon rainfall distribution: A state-wise report.',
    tags: ['Weather', 'INSIGHT'],
    date: 'October 30, 2025'
  },
  {
    image: maizeSeasonalityImg,
    title: 'Maize price seasonality suggests a bullish trend for Q4.',
    tags: ['Maize', 'INSIGHT'],
    date: 'October 29, 2025'
  },
 {
    image: maizeProductionImg, // Use the new image
    title: 'Kharif maize production estimated at 24.8 million tonnes.', // Use the new title
    tags: ['Production', 'INSIGHT'], // Updated tags
    date: 'October 28, 2025'
  }
];

const NewsInsights = () => {
  const scrollContainerRef = useRef(null);

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 350, behavior: 'smooth' });
    }
  };

  return (
    <section className="news-section">
      <div className="section-header">
        <h2>News & Insights</h2>
        <div className="header-line"></div>
      </div>
      <p className="section-subtitle">
        With precision in market trends, our insights offer strategic foresight for decisive moves in crop markets.
      </p>

      <div className="news-carousel-container">
        <div className="news-scroller" ref={scrollContainerRef}>
          {newsData.map((newsItem, index) => (
            <div key={index} className="news-card">
              <div className="card-image">
                <img src={newsItem.image} alt={newsItem.title} />
              </div>
              <div className="card-content">
                <h3>{newsItem.title}</h3>
                <div className="card-footer">
                  <div className="tags">
                    {newsItem.tags.map((tag, tagIndex) => (
                      <span key={tagIndex} className={`tag ${tag === 'INSIGHT' ? 'insight-tag' : ''}`}>
                        {tag}
                      </span>
                    ))}
                  </div>
                  <span className="date">{newsItem.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <button className="scroll-arrow right" onClick={scrollRight}><FiArrowRight /></button>
      </div>

      <div className="explore-more-container">
        <Link to="/Insights">
          <button className="explore-more-btn">Explore more</button>
        </Link>
      </div>
    </section>
  );
};

export default NewsInsights;